import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ProfileService } from '@shared/auth';

@Injectable({
  providedIn: 'root',
})
export class TimesheetApiService {
  private http = inject(HttpClient);
  private profileService = inject(ProfileService);

  private baseUri = null;

  constructor() {
    this.profileService.apiUrl$.subscribe(apiUrl => {
      this.baseUri = `${apiUrl}/api/timesheet`;
    });
  }

  getByDate(date: Date): Observable<any> {
    const dateString = date.toISOString().split('T')[0]; // YYYY-MM-DD
    const url = `${this.baseUri}/${dateString}`;
    return this.http.get(url);
  }

}
